/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  AbstractSnapshotFormComponent,
  FormState,
  FormStateBuilder,
  FormStateSnapshot,
} from '@gh/common-shared';
import { ScheduleMasterInfo } from '../../../resources/schedule-details.model';

@Component({
  standalone: false,
  selector: 'gh-sales-schedule-details-top-form',
  templateUrl: 'sales-schedule-details-top-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SalesScheduleDetailsTopFormComponent
  extends AbstractSnapshotFormComponent<ScheduleMasterInfo> {
  @Input() startDate: Date;
  @Input() endDate: Date;
  @Input() duration: number;

  constructor(private formStateBuilder: FormStateBuilder) {
    super();
  }

  protected buildForm(snapshot: FormStateSnapshot<ScheduleMasterInfo>): FormState<ScheduleMasterInfo> {
    return this.formStateBuilder.buildPlain({
      enabled: this.enabled,
      snapshot,
      children: {
        salesFolderName: { enabled: false },
        customerName: { enabled: false },
        name: { enabled: false },
        salesFolderAddedDate: { enabled: false },
      },
    });
  }
}
